<template>
  <div class="wrap-table-order">
    <table class="table table-order-grouped">
      <thead>
        <tr>
          <th class="no-wrap" v-translate>Qty</th>
          <th v-translate>Item</th>
        </tr>
      </thead>
      <tbody>
        <tr class="tr-grouped-separator">
          <td colspan="2"><div><span v-translate>Order</span>: {{ orderNo }} - <span v-translate>Staff</span>: {{ printProperty(bill.staff, 'staffs', 'ref') }} - {{ printDate(bill.updatedDate, 'HH:mm') }}</div></td>
        </tr>

        <!-- Group -->
        <template v-for="level in group.levels">
          <!-- Level -->
          <tr>
            <td colspan="2" class="pt-3 pb-0"><b>{{ printName(level.id, 'orderLevels') }}</b></td>
          </tr>
          <!-- Items -->
          <template v-if="item.type != COMMISSION_ITEM" v-for="item in level.items">
            <tr>
              <td>{{ item.qty }}</td>
              <td
                :class="{'td-mixer-name': item.type == MIXER_ITEM}">
                {{ itemName(item) }}
              </td>
            </tr>
            <!-- Note -->
            <bill-item-note :note="item.note" :view="'normal'"/>
          </template>
        </template>
      </tbody>
     </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BillItemNote from '@/components/BillItemNote.vue';

export default {
  name: 'OrderGrouped',
  props: ['group'],
  components: {
    BillItemNote,
  },
  computed: {
    orderNo() {
      return this.previousOrderSeparators.length;
    },
    ...mapState({
      bill: state => state.bill.bill,
    }),
    ...mapGetters(['previousOrderSeparators']),
  },
  methods: {
    itemName(item) {
      if(item.type == this.NORMAL_ITEM) return this.printName(item.product, 'articles');
      if(item.type == this.MIXER_ITEM) return '+' + this.printName(item.product, 'articles');
    }
  }
};
</script>
